import { navigateExternal, type AuthSessionLike } from '@bettercomp/ams-spa-auth';
import { getAmsSession } from 'service/amsSession';
import { logout as legacyLogout } from 'service/cognitoService';

/**
 * Mode-aware sign-out for every UI trigger (header menu, idle timeout, forced
 * re-login). A live AMS session revokes its refresh token, broadcasts to
 * sibling tabs on its own channel, and round-trips Cognito's /logout; without
 * one the legacy logout runs unchanged (including its bc-app-auth broadcast).
 * Both round-trips land on /logout artifact-free, which bounces to the
 * hosted-UI login form — the same terminal state as the legacy flow.
 */
export function appLogout(sessionOverride?: AuthSessionLike): void {
  // React callers pass the session from AuthContext (its state commit can beat
  // the provider's bridge effect); non-React callers rely on the bridge.
  const session = sessionOverride ?? getAmsSession();

  if (!session) {
    legacyLogout();
    return;
  }

  void session.logout().then(navigateExternal);
}
